module.exports = "<div ng-form=\"bisherForm\" title=\"{{'VORHERIGER_WERT' | translate}}\" ng-if=\"vm.showBisher() && !vm.equals(vm.getGSProperty(), vm.getFSProperty()) && (vm.errorObject.$pristine || vm.errorObject.$valid)\" class=\"dv-alert-box dv-alert-box--history dv-alert-box--input-alert\" ng-class=\"{'dv-alert-box--has-margin' : vm.hasMargin, 'dv-alert-box--is-textarea' : vm.isTextarea}\"> <div class=\"dv-alert-box__message\"> <span ng-repeat=\"line in vm.getBisher() track by $index\">{{line}}</span> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/dv-bisher/dv-bisher.html
// module id = l/Tn
// module chunks = 0